export default __webpack_public_path__ + "static/media/Rocket.df74c3f5.svg";